import React, { useEffect, useState, useRef } from "react";
import BodyContainer from "../BodyContainer";
import EventCard from "../EventCard";
// import EventCard from "../eventCard/EventCard";
import Loader from "../Loader";
import Services from "../../services/services";
import EmptyMessage from "./EmptyMessage";

function RegisteredEvents({ image, userId, userType, isNotHostOrAdmin }) {
  const timerID = useRef(null);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  const retryWithTimeInterval = () => {
    // setRetry(true);
    timerID.current = setTimeout(() => {
      getListOfEvents();
    }, 60000);
  };

  const clearRetryTimeInterval = () => {
    clearTimeout(timerID?.current);
  };

  useEffect(() => {
    getListOfEvents();
    return () => {
      clearRetryTimeInterval();
    };
  }, []);

  const getListOfEvents = () => {
    clearRetryTimeInterval();
    userId || setLoader(false);
    userId &&
      Services.list_events_controlled(userId)
        .then((res) => {
          setLoader(false);
          setData(res.data.listOfHostEvents);
          retryWithTimeInterval();
          return null;
        })
        .catch((err) => {
          setLoader(false);
          retryWithTimeInterval();
          return null;
        });
  };

  return (
    <BodyContainer title="My Events">
      {data?.length ? (
        data?.map((each) => {
          const isEventCancelled = each?.eventStatus === "cancelled";

          return (
            isEventCancelled || (
              <EventCard
                data={each}
                key={each.eventId}
                image={image}
                userType={userType}
                userId={userId}
              />
            )
          );
        })
      ) : (
        <EmptyMessage />
      )}
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default RegisteredEvents;
